import React from "react";
import { Observer } from "mobx-react";
import locale from "@bonliva-crm/locale";
import { useStore } from "@hooks";
import { GetAccommodationSelectorItems as search } from "@graphql";
import { AccommodationSelectorStore } from "./AccommodationSelectorStore";
import { AccommodationSelectorControl } from "./AccommodationSelectorControl";
import { AccommodationSelectorFilter } from "./AccommodationSelectorFilter";
import { Accommodation, Props, initialFilter } from "./utils";
import VirtualSelector from "../base/VirtualSelector";
import { AccommodationCard } from "../../../accommodations/AccommodationCard/AccommodationCard";

export const AccommodationSelector: React.FC<Props> = (props) => {
  const store = useStore(
    () =>
      new AccommodationSelectorStore({
        multi: false,
        initialFilter,
        fetch: () =>
          search
            .func(
              {
                input: {
                  text: store.filter.text
                },
                skip: 0,
                limit: 20
              },
              { fetchPolicy: "network-only" }
            )
            .then((res) => res.data.getAccommodations),
        fetchMore: ({ skip, limit }) =>
          search
            .func(
              {
                input: {
                  text: store.filter.text
                },
                limit,
                skip
              },
              { fetchPolicy: "network-only" }
            )
            .then((res) => res.data.getAccommodations),
        onChange: (item) => props.onChange(item)
      })
  );

  const selector = (
    <Observer>
      {() => {
        return (
          <VirtualSelector<Accommodation>
            store={store}
            renderControl={() => (
              <AccommodationSelectorControl {...props} onOpen={store.openSearchDialog} />
            )}
            renderFilter={() => <AccommodationSelectorFilter store={store} />}
            renderItem={(data, selected) => (
              <AccommodationCard
                data={data}
                // selected={selected} <-- for multi select
                onClick={() => store.selectItem(data)}
                style={{ margin: "8px 0" }}
              />
            )}
          />
        );
      }}
    </Observer>
  );

  return selector;
};

AccommodationSelector.defaultProps = {
  clearable: true,
  disabledFilterFields: [],
  label: locale.SelectSomething(locale.Accommodation)
};
